<div class="tgp-container" (mouseleave)="onCellLeave()">
  <div class="tgp-grid">
    <ng-container *ngFor="let row of rows">
      <div
        *ngFor="let col of cols"
        class="tgp-cell"
        [class.tgp-cell--active]="isHighlighted(row, col)"
        (mouseenter)="onCellHover(row, col)"
        (click)="onCellClick(row, col, $event)">
      </div>
    </ng-container>
  </div>
  <div class="tgp-label">
    <ng-container *ngIf="hoverRow() > 0 && hoverCol() > 0; else emptyLabel">
      {{ hoverRow() }} × {{ hoverCol() }}
    </ng-container>
    <ng-template #emptyLabel>Select table size</ng-template>
  </div>
</div>
